import gql from 'graphql-tag'

export const impiantoPage = gql`
 query impiantoPage($locale: SiteLocale) {
  impianto(locale: $locale) {
    titleGallery
    textGallery
    gallery {
      image {
        responsiveImage {
          src
          srcSet
        }
      }
      zoomImage {
        responsiveImage {
          src
          srcSet
        }
      }
    }
      seo {
        title
        image {
          url
        }
        description
      }
      statsBlock {
        number
        unit
        description
      }
      captionStats
      introTable
      textTable
      table
      videoHd
      video720
      video540
      video360
      introArchitecture
      titoloArchitecture
      textArchitecture
      fasiList {
        titolo
      }
      imageDesk {
        responsiveImage {
          src
          srcSet
        }
      }
      imageMobile {
        responsiveImage {
          src
          srcSet
        }
      }
      titleDark
      titlePayback
      subtitlePayback
      titleBottomSectionDark
      textBottomSectionDark
      backgroundImageDesk{
        responsiveImage {
          src
          srcSet
        }
      }
      backgroundImageMobile{
        responsiveImage {
          src
          srcSet
        }
      }
    }
  }
`
